import React from 'react'
import styled from 'styled-components'
import { device } from '../../../config/theme/breakpoints'
import { ArrowRight } from '@styled-icons/bootstrap'
import TitleSection from '../../../components/title-section/title-section'
import PaymentMethods from '../../landing/components/payment-methods/payment-methods'
import AlertInfo from './components/alert-info/alert-info'
import { CheckCircle } from '@styled-icons/bootstrap'
import Visa from '../../../assets/img/visa_logo.png'
import { NavLink } from 'react-router-dom'

const ContainerTextTop = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  gap: 20px;
  flex-wrap: wrap;

  > h3 {
    color:  ${p => p.theme.palette.primary.main};
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;

    @media ${device.tablet}{
      width: 48%;
      justify-content: flex-end;
    }
  }

  > h3 svg {
    width: 20px;
    color:  ${p => p.theme.palette.secondary.main};
    margin: 0 10px;
  }

  > p{
    color:  ${p => p.theme.palette.text.grayLight};
    font-size: 12px;
    margin: 0;
    width: 100%;
    text-align: center;

    @media ${device.tablet}{
      width: 48%;
      text-align: left;
    }
  }
`

const ContainerTerms = styled.div`
  display: flex;
  margin-top: 20px;

  > svg{
    color: red;
    max-width: 20px;
    margin-right: 5px;
  }

  > p{
    margin: 0;
    font-size: 12px;
    align-self: center;
    color: ${p => p.theme.palette.text.gray}
  }
`

const ContainerBody = styled.div`
  width: 100%;
`

const ContainerItinerario = styled.div`
  width: 80%;
  margin: auto;
  border-radius: 20px;
  box-shadow: 0px 2px 12px 0px #d9d9d9;
`
const ContainerHeader = styled.div`
  background:  ${p => p.theme.palette.primary.main};
  text-align: center;
  border-radius: 20px 20px 0 0;
  padding: 4px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 20px;
  height: 55px;
  
  > h4 {
    color: white;
    margin: 0;
  }
`
const TableWrapper = styled.div`
  width: fit-content;
  margin: auto;
  padding: 30px 10px;
`
const HeadTableWrapper = styled.div`
  border-bottom: 1px solid ${p => p.theme.palette.grayLight};
  padding-bottom: 10px;

  > th {
    color:  ${p => p.theme.palette.primary.main};
    margin-left: 10px;
    margin-right: 10px;
    text-align: left;
    font-size: 14px;
    padding: 5px 10px;
    min-width: 130px;
  }
`
const BodyTableWrapper = styled.div`
  padding-top: 10px;

  > tr td {
    color:  ${p => p.theme.palette.text.grayLight};
    font-size: 12px;
    padding: 15px 10px;
    min-width: 130px;
  }
`
const ContainerMethods = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 25px;
  
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    > div {
      text-align: center;
      margin-bottom: 20px;
    }
  }
`

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background: ${p => p.theme.palette.text.grayLight};
  border-radius: 50px;
`
const VISAButton = styled(NavLink)`
  display: flex;
  background: #364E97;
  border-radius: 8px;
  color: white;
  border: none;
  outline: none;
  cursor: pointer;
  box-shadow: 0px 2px 12px 0px #d9d9d9;
  text-decoration: none;
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 8px 30px;
  gap: 10px;

  > p {
    margin: 0;
  }

  > img {
    max-width: 30px;
  }
`
const ContainerWrapperTable = styled.div`
  overflow: auto;
`

interface IOwnProps {
  onClick: (step: number) => void
}

const PaymentComponent: React.FunctionComponent<IOwnProps> = ({ onClick }) => {
  return (
    <>
      <ContainerTextTop>
        <h3>
          Lima
          <ArrowRight />
          Chiclayo
        </h3>
        <p>Miercoles 10 de Agosto</p>
      </ContainerTextTop>
      <ContainerBody>
        <ContainerItinerario>
            <ContainerHeader><h4>Detalle itinerario</h4></ContainerHeader>
              <ContainerWrapperTable>
              <TableWrapper>
                <HeadTableWrapper>
                  <th>Ruta</th>
                  <th>Servicio</th>
                  <th>Fecha de viaje</th>
                  <th>Hora de salida</th>
                  <th>Hora de llegada</th>
                  <th>Costo</th>
                </HeadTableWrapper>
                <BodyTableWrapper>
                  <tr>
                    <td>CHICLAYO - LIMA</td>
                    <td>BUSCAMA</td>
                    <td>10/08/2022</td>
                    <td>06:30PM</td>
                    <td>08:30AM</td>
                    <td>100.00</td>
                  </tr>
                  <tr>
                    <td>CHICLAYO - LIMA</td>
                    <td>BUSCAMA</td>
                    <td>10/08/2022</td>
                    <td>06:30PM</td>
                    <td>08:30AM</td>
                    <td>100.00</td>
                  </tr>
                  <tr>
                    <td>CHICLAYO - LIMA</td>
                    <td>BUSCAMA</td>
                    <td>10/08/2022</td>
                    <td>06:30PM</td>
                    <td>08:30AM</td>
                    <td>100.00</td>
                  </tr>
                </BodyTableWrapper>
              </TableWrapper>
            </ContainerWrapperTable>
        </ContainerItinerario>
      </ContainerBody>
      <ContainerMethods>
        <TitleSection preTitle='' title='Formas de Pago' />
        <div>
          <VISAButton to='/pago-exitoso'>
            <p>Paga con</p>
            <img src={Visa} alt='Logo de visa'/>
          </VISAButton>
          <ContainerTerms>
            <CheckCircle />
            <p>Debes aceptar nuestros términos y condiciones</p>
          </ContainerTerms>
        </div>
        <Divider />
      </ContainerMethods>
      <PaymentMethods />
      <AlertInfo />
    </>
  )
}

export default PaymentComponent